import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Currency from '../Currency';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { selectedDepartmentTypes } from '../../types/shop';

const PdpProductTotals = ({ totals, selectedDepartment }) => {
  if (!totals) return null;

  return (
    <>
      <div className='body-2 u-bold flex-container row space-between mt6-sm'>
        <span>
          <TranslatedCopy id='global.totalQuantity' />
        </span>
        <span data-desc='pdp__info_total-quantity' className='pdp__info_totalVal'>
          {totals.qty}
        </span>
      </div>
      <div className='body-2 u-bold flex-container row space-between mt2-sm'>
        <span>
          <TranslatedCopy id='global.total' />
        </span>
        <span data-desc='pdp__info_total-dollar-amount' className='pdp__info_totalVal'>
          <Currency type={selectedDepartment.code} value={totals.price || '0'} />
        </span>
      </div>
    </>
  );
};

PdpProductTotals.defaultProps = {};

PdpProductTotals.propTypes = {
  selectedDepartment: selectedDepartmentTypes.isRequired,

  totals: PropTypes.shape({
    qty: PropTypes.number,
    price: PropTypes.number
  }).isRequired
};

export default PdpProductTotals;
